import { type FC, useEffect, useState } from 'react';
import { Flex } from '@chakra-ui/react';

import SunshineLoader from 'components/_core/SunshineLoader';

const DEFERRED_LOADER_DELAY = 500;

const Loader: FC = () => (
  <Flex
    alignItems="center"
    flexGrow={1}
    height="100%"
    justifyContent="center"
    width="100%"
  >
    <SunshineLoader />
  </Flex>
);

export const DeferredLoader = () => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(true);
    }, DEFERRED_LOADER_DELAY);

    return () => clearTimeout(timer);
  }, []);

  return showLoader ? <Loader /> : null;
};

export default Loader;
